export default function Footer() {
    return (
      <footer className="mt-12 py-4 text-gray-400 dark:text-gray-500 text-sm border-t border-gray-300 dark:border-gray-700">
        Created by <a href="https://x.com/nima_owji" className="underline">Nima Owji</a> | &copy;2026
      </footer>
    );
  }  